import styled from "styled-components";
import { CardProps } from "./Card";
import { Fitty } from "./Fitty";
import { useEffect, useState } from "react";

const darkOrange = "#944227";

const CardTitleBackground = styled.div<{ titleBackground: string }>`
  position: absolute;
  top: calc(var(--h) * 100);
  left: calc(var(--w) * 28);
  height: calc(var(--h) * 169);
  aspect-ratio: 8.2605;

  background-image: url(${({ titleBackground }) =>
    encodeURI(`/assets/resources/${titleBackground}`)});
  background-size: contain;
  background-repeat: no-repeat;
`;

const CardTitleType = styled.p<{ type: string }>`
  margin: 0;
  padding: 0;
  position: absolute;
  top: 20%;
  left: 9%;
  width: 8%;
  font-size: calc(20 * var(--h));
  font-family: "Gunplay";
  text-align: center;
  color: ${({ type }) =>
    !["troops", "nations"].includes(type) ? "white" : darkOrange};
`;

const CardTitleNumber = styled.p<{ type: string }>`
  margin: 0;
  padding: 0;
  position: absolute;
  top: 33%;
  left: 9%;
  width: 8%;
  font-size: calc(60 * var(--h));
  font-family: "Gunplay";
  text-align: center;
  color: ${({ type }) =>
    !["troops", "nations"].includes(type) ? "white" : darkOrange};
`;

const sizes = [40, 55, 65];

const CardTitleTitle = styled.div<{ type: string; fontSize?: number }>`
  margin: 0;
  padding: 0;
  position: absolute;
  color: ${({ type }) =>
    ["troops", "nations"].includes(type) ? "white" : darkOrange};
  font-family: "StencilStd", cursive;
  text-align: center;
  top: 31%;
  left: 19%;
  width: 62%;
  height: 45%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    max-width: 100;
    font-size: calc(${({ fontSize }) => sizes[fontSize ?? 2]} * var(--h));
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const CardTitleContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export function CardTitle(props: CardProps) {
  console.log(props);
  return (
    <CardTitleBackground titleBackground={props.titleBackground}>
      <CardTitleContainer>
        <CardTitleType type={props.type}>
          {props.type.toUpperCase()}
        </CardTitleType>
        <CardTitleNumber type={props.type}>{props.id}</CardTitleNumber>
        <CardTitleTitle type={props.type} fontSize={props.titleSize}>
          <span>{props.title}</span>
        </CardTitleTitle>
      </CardTitleContainer>
    </CardTitleBackground>
  );
}
